<template>
    <div class="quickpay-deadline-selection">
        <QuickpayPaymentHeader
            :companyName="data.corporation.name"
            :amount="data.document.amount_due"
            :currency="data.document.currency"
            :logoUrl="data.corporation.logoUrl"
            :hideAmount="data.document.hide_amount_due"
        />
        <QuickpayDownloadDocument
            :docType="data.document.doctype"
            :docId="data.document.id"
            :corpId="data.document.corpid"
            :pdfUrl="data.document.pdf_link"
            :pdfReady="data.document.pdf_ready"
            :hash="hash"
            :documentNumber="data.document.number"
            :documentStep="data.document.step"
            :expired="data.document.expired"
            class="quickpay-deadline-selection__download-document"
        />
        <QuickpayDeadlines
            :deadlines="data.deadlines"
            :currency="data.document.currency"
            :selectable="true"
            :preselectedDeadlineId="preselectedDeadlineId"
            :autoExpand="autoExpand"
            @pay-deadline="handlePayDeadline"
            @pay-whole-document="handlePayWholeDocument"
        />
    </div>
</template>

<script>
import QuickpayPaymentHeader from 'vcomponents/quickpay/QuickpayPaymentHeader.vue';
import QuickpayDeadlines from './QuickpayDeadlines.vue';
import QuickpayDownloadDocument from './QuickpayDownloadDocument.vue';

export default {
    components: {
        QuickpayPaymentHeader,
        QuickpayDeadlines,
        QuickpayDownloadDocument,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        hash: {
            type: String,
            required: true,
        },
        preselectedDeadlineId: {
            type: Number,
            default: null,
        },
        autoExpand: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['select-deadline', 'pay-whole-document'],
    methods: {
        handlePayDeadline(deadline) {
            this.$emit('select-deadline', deadline);
        },
        handlePayWholeDocument() {
            this.$emit('pay-whole-document');
        },
    },
};
</script>

<style lang="scss" scoped>
.quickpay-deadline-selection {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: var(--spacing-3);

    @media (max-width: 1023px) {
        gap: var(--spacing-4);
    }

    &__download-document {
        @media (min-width: 1024px) {
            display: none;
        }
    }
}
</style>
